import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 15px 25px;
  background: #005092;
  color: white;
  font-size: 16px;
`;

export const Container = styled.div`
  width: 49vw;
  max-width: 1000px;
  min-width: 500px;
  height: 100%;
  padding: 20px 15px;
`;
